import {computed} from 'vue';

export function useScreenDimensions() {

    const isSmallerMobile = computed(() => {
        return window.innerWidth <= 320;
    });

    const isMobile = computed(() => {
        return window.innerWidth < 768;
    });

    const isTablet = computed(() => {
        return window.innerWidth >= 768;
    });

    const isDesktop = computed(() => {
        return window.innerWidth >= 1280;
    });

    return {
        isMobile,
        isTablet,
        isDesktop,
        isSmallerMobile,
    };
}


